import { ReactNode } from "react";
import { TermsAcceptanceBanner } from "./TermsAcceptanceBanner";

interface RequireTermsAcceptanceProps {
  children: ReactNode;
}

export const RequireTermsAcceptance = ({ children }: RequireTermsAcceptanceProps) => {
  return (
    <>
      <TermsAcceptanceBanner />
      {children}
    </>
  );
};
